/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const goal = (
	<SVG width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M27.867 12.5823C32.3058 12.5823 35.9173 16.1937 35.9173 20.6326C35.9173 25.0715 32.3058 28.6829 27.867 28.6829C23.4281 28.6829 19.8167 25.0715 19.8167 20.6326C19.8167 16.1937 23.4281 12.5823 27.867 12.5823ZM27.867 8.55713C21.1964 8.55713 15.7915 13.9643 15.7915 20.6326C15.7915 27.3009 21.1986 32.7081 27.867 32.7081C34.5353 32.7081 39.9424 27.3009 39.9424 20.6326C39.9424 13.9643 34.5353 8.55713 27.867 8.55713Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M27.867 24.6486C30.0851 24.6486 31.8833 22.8505 31.8833 20.6324C31.8833 18.4143 30.0851 16.6162 27.867 16.6162C25.6489 16.6162 23.8508 18.4143 23.8508 20.6324C23.8508 22.8505 25.6489 24.6486 27.867 24.6486Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M12.3434 40.452C12.643 41.3934 12.4328 41.7579 11.762 42.4288C10.7848 43.406 6.67686 47.5139 6.17371 48.0171C5.22333 48.9675 4.32438 48.3547 4.09181 47.5944C3.9487 47.1293 3.33374 45.1637 3.33374 45.1637L11.3326 37.1648C11.3326 37.1648 11.9342 39.1662 12.3411 40.452H12.3434Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M8.04983 36.1585C7.10839 35.8589 6.74389 36.0691 6.07303 36.7399C5.09581 37.7171 0.987918 41.825 0.484773 42.3282C-0.465611 43.2786 0.147107 44.1775 0.907415 44.4101C1.37254 44.5532 3.33816 45.1681 3.33816 45.1681L11.337 37.1693C11.337 37.1693 9.33565 36.5677 8.04983 36.1607V36.1585Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M27.8669 4.52516C36.7491 4.52516 43.9742 11.7503 43.9742 20.6325C43.9742 29.5147 36.7491 36.7398 27.8669 36.7398C18.9847 36.7398 11.7595 29.5147 11.7595 20.6325C11.7595 11.7503 18.9869 4.52516 27.8669 4.52516ZM27.8669 0.5C16.7485 0.5 7.73438 9.51412 7.73438 20.6325C7.73438 31.7509 16.7485 40.765 27.8669 40.765C38.9853 40.765 47.9994 31.7509 47.9994 20.6325C47.9994 9.51412 38.9875 0.5 27.8669 0.5Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M28.0505 21.8601C28.7549 21.1534 27.3438 19.7468 26.6394 20.4535L4.23047 42.8624L5.63927 44.2712"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
	</SVG>
);
